;(function () {
  'use strict'

  angular
    .module('contrast.date')
    .directive('csDateRangeModel', csDateRangeModel)

  function csDateRangeModel(csDateRangePickerService, TimeService) {
    'ngInject'

    return {
      restrict: 'A',
      require: 'ngModel',
      priority: 1,
      link: function (scope, elem, attrs, ngModelCtrl) {
        ngModelCtrl.$parsers.push(function (viewVal) {
          if (angular.isString(viewVal)) {
            var parsed = _parseViewValue(viewVal)
            if (angular.isObject(parsed)) {
              return parsed
            }
          }
          return {
            startDate: null,
            endDate: null
          }
        })

        function _parseViewValue(viewVal) {
          if (angular.isString(viewVal)) {
            var index = viewVal.indexOf(' - '),
              delimLen = 3
            return {
              startDate: viewVal.substr(0, index),
              endDate: viewVal.substr(index + delimLen)
            }
          }
          return false
        }

        ngModelCtrl.$validators.isValidFormat = function (modelVal, viewVal) {
          if (angular.isUndefined(viewVal)) {
            return true
          } // avoid invalid when empty
          var parsed = _parseViewValue(viewVal)
          if (angular.isObject(parsed)) {
            var format = TimeService.getDateTimeFormat()
            var start = moment(parsed.startDate, format)
            var end = moment(parsed.endDate, format)
            return (
              start.isValid() &&
              end.isValid() &&
              (start.isBefore(end) || start.isSame(end))
            )
          }
          return false
        }

        // model -> view
        ngModelCtrl.$formatters.push(function (modelVal) {
          var response = csDateRangePickerService.formatModelToView(modelVal)
          return response
        })

        scope.$watch(function () {
          ngModelCtrl.$render()
        })
      }
    }
  }
})()
